import { render, staticRenderFns } from "./MoleculeContentEditorBlockLink.vue?vue&type=template&id=1141e823&"
import script from "./MoleculeContentEditorBlockLink.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditorBlockLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports